exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "body,html{margin:0;height:100%;font-family:Roboto,sans-serif;background:#213a4a}.loadedContent__2Cu5r .spinner__3kgdE{display:none}", "", {"version":3,"sources":["/Users/jose/Desktop/Projects/Boon/GalwayBayFM-Popup-Player/src/components/main/style.scss"],"names":[],"mappings":"AAAA,UACC,SACA,YACA,8BACA,kBAAmB,CACnB,sCAIC,YAAa,CACb","file":"style.scss","sourcesContent":["html, body {\n\tmargin: 0;\n\theight: 100%;\n\tfont-family: 'Roboto', sans-serif;\n\tbackground: #213a4a;\n}\n\n.loadedContent {\n\t.spinner {\n\t\tdisplay: none;\n\t}\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"loadedContent": "loadedContent__2Cu5r",
	"spinner": "spinner__3kgdE"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/main/style.scss
// module id = JOuJ
// module chunks = 0